import { render, staticRenderFns } from "./commonPage.vue?vue&type=template&id=f445cbd6&scoped=true&"
import script from "./commonPage.vue?vue&type=script&lang=js&"
export * from "./commonPage.vue?vue&type=script&lang=js&"
import style0 from "./commonPage.vue?vue&type=style&index=0&id=f445cbd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f445cbd6",
  null
  
)

export default component.exports